export const FeedContentWidgetType = ['date-widget', 'itinerary-widget'] as const;

// InvertedVenueHoursStatus takes closed as default, open has the same meaning as in regular
// `VenueHoursStatus` (open without service), and adds a new value `free`, which means the venue is
// available
export const InvertedVenueHoursStatus = ['free', 'open'] as const;

export const VenueDispositionType = ['openCloseHours', 'mealPeriods'] as const;

export const VenueLocationLong = ['aft', 'mid', 'fwd'] as const;
export const VenueLocationLat = ['prt', 'stb'] as const;

export const TemplateType = ['sailing', 'project', 'template'] as const;
